import Notes from './Notes';

export default Notes;



// WEBPACK FOOTER //
// ./src/containers/site-visits/notes/index.js